import styled from 'styled-components';

export const FixedContainer = styled.div`
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
`;

export const CenteredFixedContainer = styled(FixedContainer)`
    display: flex;
    justify-content: center;
    align-items: center;
`;
